import i18n from '@/i18n';
import {
  isNavSectionOpen,
  NavSectionInterface,
  toSectionMap,
} from '@/lib/navigation/helpers';
import { navItems } from '@/lib/navigation/navItems';
import {
  companyCanAccess,
  Feature,
} from '@/lib/permission/companyAccessFeatures';
import { userCan } from '@/lib/permission/userCan';
import { useUserCan } from '@/lib/permission/userCanComposable';
import store from '@/store';
import { Icon } from '../enum/Icon';

export const reportsNav = toSectionMap({
  shiftCost: async (): Promise<NavSectionInterface> => ({
    name: i18n.tc('nav.reports.menu.hoursAndCosts'),
    icon: Icon.CalendarWeek,
    open: isNavSectionOpen(reportsNav, 'shiftCost'),
    hide: !(
      companyCanAccess(Feature.Reports) &&
      useUserCan(store.getters.loggedInEmployee).viewLabourCosts()
    ),
    children: [
      navItems.shiftDailyTotals(),
      navItems.shiftTotalsByEmployee(),
      navItems.shiftTotalsByJobRole(),
      navItems.shiftTotalsByLocation(),
      navItems.shiftTotalsByGroup(),
      navItems.shiftTotalsByEmploymentType(),
      await navItems.salesVsCost(),
    ],
  }),
  timeAttendance: (): NavSectionInterface => ({
    name: i18n.tc('nav.reports.menu.timeAttendance'),
    icon: Icon.Clock,
    open: isNavSectionOpen(reportsNav, 'timeAttendance'),
    hide: !userCan.viewTimeAttendanceReports(),
    children: [navItems.averageWeeklyHours()],
  }),
  timeOff: (): NavSectionInterface => ({
    name: i18n.tc('nav.reports.menu.timeOff'),
    icon: Icon.Plane,
    open: isNavSectionOpen(reportsNav, 'timeOff'),
    hide: !userCan.viewTimeOffReports(),
    children: [
      navItems.leaveByEmployee(),
      navItems.leaveBalances(),
      navItems.absenceReport(),
      navItems.bradfordFactorReport(),
    ],
  }),
  logs: (): NavSectionInterface => ({
    name: i18n.tc('nav.reports.menu.logs'),
    icon: Icon.ClipboardList,
    open: isNavSectionOpen(reportsNav, 'logs'),
    hide: !userCan.viewMessageLogs(), // might be changed if 'children' array would have more items
    children: [navItems.messageHistory()],
  }),
});
